import {EndorsementTypeList} from "./EndorsementTypeList";
import {EndorsementTypeEdit} from "./EndorsementTypeEdit";
import {EndorsementTypeCreate} from "./EndorsementTypeCreate";

export default {
    list: EndorsementTypeList,
    create: EndorsementTypeCreate,
    edit: EndorsementTypeEdit
};
